export default {
      id: "oc-res-routetable-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-routetable",
      toString: function () {
        return this.url;
      }
    }